<template>
  <div class="manage-default-box">
    <div class="main-box clear-both">
      <LeftNav :status='2'></LeftNav>
      <div class="customer-mail-display">
        <h2>送信メール作成</h2>
        <div class="customer-mail-box">
          <div class="customer-mail-list-box">
            <h3>送信対象</h3>
            <table>
              <thead>
                <tr>
                  <th v-for="item in list_head" :key="item.id" :class="item.class">{{ item.title }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in list">
                  <tr :key="item.id">
                    <td class="td-id">{{ item.id }}</td>
                    <td class="td-name">{{ item.customer_name }}</td>
                    <td class="td-mail"><p>{{ item.mail }}</p></td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="mail-info-box">
            <h3>送信情報</h3>
            <p class="title">件名</p>
            <input type="text" class="subject-text" v-model="subject">
            <p class="title">本文</p>
            <textarea class="content-text" v-model="content"></textarea>
            <button @click="send_mail_check">送信する</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/views/components/manage/LeftNav';

export default {
  name: 'manageDefault',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftNav,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      list: [],
      list_head: [
        {id: 1, title: '会員ID', class: 'th-id'},
        {id: 2, title: '会員名', class: 'th-name'},
        {id: 3, title: 'メールアドレス', class: 'th-mail'},
      ],
      subject: '',
      content: '',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.list = this.$store.getters['mCustomerList/check_customer_list'];
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    send_mail_check () {
      if (this.subject === '') {
        this.$alert('alert', '件名が入力されていません。');
        return;
      }
      if (this.content === '') {
        this.$alert('alert', '本文が入力されていません。');
        return;
      }
      this.$alert('alert', 'メールを送信しますか？', this.send_mail, this.send_mail_ng);
    },
    send_mail () {
      let id_arr = [];
      let i;
      let len = this.list.length;
      for (i = 0; i < len; i++) {
        id_arr.push(this.list[i].id);
      }
      let ld = new this.$loader(this);
      ld._m_data_set({token: this.$store.getters['mLoginInfo/login_token'],
        customer_list: id_arr,
        subject: this.subject,
        content: this.content});
      ld._post_cb_f = this.send_mail_cb;
      ld._load_start('manage/customer_mail_send.php');
    },
    send_mail_ng () {
    },
    send_mail_cb (data) {
      if (data.res === 1) {
        this.$alert('alert', 'メールを送信しました。');
        this.$router.push({path: '/manage/customer_list'});
      } else {
        this.$alert('alert', 'メールの送信に失敗しました。。');
      }
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-default-box {
  .customer-mail-display {
    min-width: 1108px;
    padding: 16px;
    flex: 1;
    h2 {
      margin-bottom: 20px;
    }
    .customer-mail-box {
      display: flex;
      justify-content: center;
      .customer-mail-list-box {
        table {
          margin: 0 auto;
          thead {
            display:block;
            tr {
              background-color: $manage-table-head-bg-color;
            }
            th {
              border: 1px solid $manage-table-border-color;
              border-bottom: none;
              padding: 5px 0;
            }
            th.th-id {
              width: 80px;
            }
            th.th-name {
              width: 160px;
              padding: 0 10px;
            }
            th.th-mail {
              width: 270px;
            }
          }
          tbody{
            display:block;
            overflow-y:scroll;
            height: calc(100vh - 154px);
            min-height: 320px;
            width: 552px;
            td {
              padding: 10px 0;
              border: 1px solid $manage-table-border-color;
            }
            td.td-id {
              width: 80px;
            }
            td.td-name {
              width: 160px;
              text-align: left;
              padding: 0 10px;
            }
            td.td-mail {
              text-align: left;
              width: 270px;
              p {
                margin-left: 10px;
                word-break: break-all;
              }
            }
          }
        }
      }
      .mail-info-box {
        margin-left: 20px;
        max-width: 900px;
        width: 100%;
        .title {
          text-align: left;
          font-weight: bold;
          margin-bottom: 10px;
          border-left: 6px solid #738f53;
          padding: 3px 0 3px 10px;
        }
        .subject-text {
          margin-bottom: 10px;
          height: 38px;
        }
        .content-text {
          height: calc(100vh - 345px);
          font-size: 1.2rem;
        }
      }
      button {
        outline: 0;
        margin-top: 10px;
        border: none;
        color: #FFF;
        width: 400px;
        height: 50px;
        font-weight: bold;
        font-size: 1.2rem;
        border-radius: 5px;
        cursor: pointer;
      }

    }
  }
}
</style>
